<template>
  <el-dialog
    class="process-mind-map-dialog process-mind-map-source-dialog fishbone-form-detail-dialog prd-out-detail-dialog"
    v-dialogDrag
    :visible.sync="innerVisible"
    width="96vw"
    append-to-body
    top="4vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="loadData"
    @closed="resetData">
    <div slot="title" class="fishbone-form-detail-dialog__title">
      <span>{{ $LANG('', '领料出库单') }}</span>
    </div>
    <div class="fishbone-form-detail-dialog__body">
      <div class="prd-out-detail-dialog__filters">
        <el-input
          v-model="filters.materialCode"
          size="mini"
          clearable
          :placeholder="$LANG('', '物料编码')"
          :aria-label="$LANG('', '物料编码')">
        </el-input>
        <el-input
          v-model="filters.materialName"
          size="mini"
          clearable
          :placeholder="$LANG('', '物料名称')"
          :aria-label="$LANG('', '物料名称')">
        </el-input>
        <el-input
          v-model="filters.specification"
          size="mini"
          clearable
          :placeholder="$LANG('', '规格型号')"
          :aria-label="$LANG('', '规格型号')">
        </el-input>
        <el-button class="prd-out-detail-dialog__reset" size="mini" @click="resetFilters">{{ $LANG('', '重置') }}</el-button>
      </div>
      <el-table
        :data="filteredTableData"
        border
        size="small"
        ref="detailTable"
        class="custom-table-border fishbone-form-detail-dialog__table"
        v-loading="loading"
        :element-loading-text="$LANG('1959', '加载中')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 251, 255, 0.8)"
        :cell-style="{ padding: '2px' }"
        :header-cell-style="headStyle"
        cell-class-name="clearPadding2"
        height="calc(88vh - 97px)"
        highlight-current-row>
        <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
        <el-table-column
          v-for="item in visibleColumns"
          :key="item.key"
          :prop="item.key"
          :label="item.title"
          show-overflow-tooltip
          :align="item.align"
          :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
          :min-width="getColumnMinWidth(item)">
          <template slot-scope="scope">
            <el-checkbox
              v-if="item.edcss === 'checkbox'"
              disabled
              true-label="Y"
              false-label="N"
              v-model="scope.row[item.key]">
            </el-checkbox>
            <el-link v-else-if="item.key === 'IDNO'" :underline="false">
              <span class="prd-out-detail-dialog__idno">{{ displayText(scope.row[item.key]) }}</span>
            </el-link>
            <span v-else v-text="displayText(scope.row[item.key])"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { getTabColOrData } from '../../api/user'

const HIDDEN_LIST_COLUMN_KEYS = ['SEL', 'BOMUNITNM', 'BOMNUM']

export default {
  name: 'PrdOutDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      loading: false,
      columns: [],
      tableData: [],
      filters: {
        materialCode: '',
        materialName: '',
        specification: ''
      }
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    visibleColumns: function () {
      return this.columns.filter(function (item) {
        return item.thide === 'N' && HIDDEN_LIST_COLUMN_KEYS.indexOf(String(item.key || '').toUpperCase()) === -1
      })
    },
    filteredTableData: function () {
      var materialCode = String(this.filters.materialCode || '').trim().toLowerCase()
      var materialName = String(this.filters.materialName || '').trim().toLowerCase()
      var specification = String(this.filters.specification || '').trim().toLowerCase()
      return this.tableData.filter(function (row) {
        var rowMaterialCode = String(row.MATNO || '').toLowerCase()
        var rowMaterialName = String(row.MATNM || '').toLowerCase()
        var rowSpecification = String(row.MATDESC || '').toLowerCase()
        return (!materialCode || rowMaterialCode.indexOf(materialCode) !== -1) &&
          (!materialName || rowMaterialName.indexOf(materialName) !== -1) &&
          (!specification || rowSpecification.indexOf(specification) !== -1)
      })
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },
 
    tableUrl: function () {
      return  'xuper_auth/getTableRecMany'
    }
  },
  methods: {
    resetData: function () {
      this.loading = false
      this.columns = []
      this.tableData = []
      this.resetFilters()
    },
    resetFilters: function () {
      this.filters.materialCode = ''
      this.filters.materialName = ''
      this.filters.specification = ''
    },
    loadData: function () {
      this.loading = true
      this.loadColumns().then(function (columns) {
        this.columns = columns
        return this.loadRows().catch(function () {
          return []
        })
      }.bind(this)).then(function (rows) {
        this.tableData = rows || []
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.loading = false
      }.bind(this))
    },
    loadColumns: function () {
      return getTabColOrData(this.tableUrl,  'v_sys_form_fld', 'idseq', '17442', 'lstseq', '2358', '', '', ' order by sortby,lstseq').then(function (res) {
        var list = (res && res.result) || []
        return list.map(function (item) {
          return {
            title: this.$translate.getColTitle(item, this.$store.state.lang),
            key: item.key,
            align: item.align,
            width: item.width,
            thide: item.THIDE,
            fhide: item.FHIDE,
            edcss: item.EDCSS,
            disabled: item.DISABLED,
            dotnum: item.DOTNUM,
            sortable: item.SORTABLE
          }
        }.bind(this))
      }.bind(this))
    },
    loadRows: function () {
      var payload
      try {
        payload = this.getDynamicPayload()
      } catch (error) {
        return Promise.resolve([])
      }
      return getTabColOrData(
        this.tableUrl,
 
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (res) {
        return (res && res.result) || []
      })
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var missing = []
      var params = {
        ORDNO: row.ORDNO,
        MATNO: row.MATNO,
        CORPID: row.CORPID
      }
      Object.keys(params).forEach(function (key) {
        if (params[key] === undefined || params[key] === null || params[key] === '') missing.push(key)
      })
      if (missing.length) throw new Error('MISSING_SOURCE_PARAMS')
      return params
    },
    escapeQueryValue: function (value) {
      return String(value).trim().replace(/'/g, "''")
    },
    getDynamicPayload: function () {
      var params = this.getRequiredSourceParams()
      return {
        p_key: 'IDTY',
        p_value: 'PRDOUT',
        p_key2: 'corpid',
        p_value2: params.CORPID,
        p_key3: '',
        p_value3: '',
        p_table: 'V_IC_STKDTL_QRY',
        p_cond: " and IDNO like '%%' and ORDNO like '%" + this.escapeQueryValue(params.ORDNO) + "%' and ORDMATNO like '%" + this.escapeQueryValue(params.MATNO) + "%' order by IDNO desc"
      }
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    getColumnMinWidth: function (item) {
      item = item || {}
      var configuredWidth = parseInt(item.width, 10) || 0
      var title = String(item.title || '')
      var isSortable = item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'
      var titleWidth = Array.from(title).reduce(function (total, char) {
        return total + (/[\u4e00-\u9fff]/.test(char) ? 14 : 8)
      }, 0)
      var headerWidth = titleWidth + (isSortable ? 22 : 0) + 24
      return Math.max(configuredWidth, headerWidth)
    },
    headStyle: function (params) {
      var column = params.column || {}
      if (column.property === 'AMT' || column.property === 'QTY' || column.property === 'POQTY' || column.property === 'ACTQTY') return 'color:red'
    }
  }
}
</script>

<style scoped>
.fishbone-form-detail-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  color: #1f2f3d;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.fishbone-form-detail-dialog__body {
  min-height: 70vh;
}
.prd-out-detail-dialog__filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.prd-out-detail-dialog__filters .el-input {
  width: 150px;
}
.fishbone-form-detail-dialog__table {
  width: 100%;
}
.prd-out-detail-dialog__idno {
  color: #409eff;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 1px solid #409eff;
}
</style>

<style lang="less">
.process-mind-map-dialog.prd-out-detail-dialog {
  .el-table th > .cell {
    white-space: nowrap;
    word-break: keep-all;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .prd-out-detail-dialog__filters .el-input--mini .el-input__inner {
    height: 28px !important;
    min-height: 28px !important;
    line-height: 28px !important;
    font-size: 12px !important;
  }
  .prd-out-detail-dialog__filters .el-input--mini .el-input__icon {
    height: 28px;
    line-height: 28px;
  }
  .prd-out-detail-dialog__filters .el-input__suffix-inner {
    display: inline-flex;
    align-items: center;
    height: 100%;
    vertical-align: top;
  }
  .prd-out-detail-dialog__reset {
    height: 28px !important;
    min-height: 28px !important;
    padding: 0 12px !important;
    font-size: 12px !important;
    line-height: 28px !important;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
}
</style>
